import { useLanguage } from "@web/lib/contexts/language-context"
import { useEffect, useState } from "react"

const DOTS = [".", "..", "..."]

export function QrCodeQueryLoading() {
	const { t } = useLanguage()
	const [dotIndex, setDotIndex] = useState(0)

	useEffect(() => {
		const interval = setInterval(() => {
			setDotIndex((prev) => (prev + 1) % DOTS.length)
		}, 500)
		return () => clearInterval(interval)
	}, [])

	return (
		<div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background gap-10">
			<div className="relative flex items-center justify-center">
				<span className="absolute h-24 w-24 rounded-full border-2 border-primary/10 animate-ping animation-duration-[2s]" />
				<span className="absolute h-16 w-16 rounded-full border-2 border-primary/20 animate-ping animation-duration-[1.5s] [animation-delay:300ms]" />

				<div className="relative z-10 h-16 w-16 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center">
					<svg
						className="h-7 w-7 animate-spin text-primary"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
					>
						<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
						<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
					</svg>
				</div>
			</div>
			<div className="flex flex-col items-center gap-1.5">
				<p className="text-lg font-semibold tracking-tight">
					{t.common.loadingConsultation}
					<span className="inline-block w-6 text-primary">{DOTS[dotIndex]}</span>
				</p>
			</div>

			<div className="w-48 h-1 bg-muted rounded-full overflow-hidden">
				<div className="h-full w-1/2 bg-primary rounded-full animate-[slide_1.8s_ease-in-out_infinite] origin-left" />
			</div>
		</div>
	)
}